// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"b06c90d7","289":"0fbdcd43","315":"8ae00e2c","637":"d61d820e","670":"6b839edd","758":"edad2367","966":"10683367"}[chunkId] + ".chunk.js";
};